import { Resolutions, Timeout } from "../common/const";
import { isWidthResize } from "../common/utils";

/**
 * @aside_menu
 * @constructor
 */
class Menu {
    /**
     /**
     * @param {Object} el page container
     * @param {function} cb Callback invoked on close/open menu
     */
    constructor(el) {
        this.el = el;
        this.attr = this.el.getAttribute(`data-menu`);
        this.openBtns = document.querySelectorAll(`[data-menu-open="${this.attr}"]`);
        this.closeBtns = document.querySelectorAll(`[data-menu-close]`);
        this.overlay = document.querySelector(`[data-overlay]`);
        this.setTimeoutConst = 0;

        this.closeMenu = this.closeMenu.bind(this);
        this.openMenu = this.openMenu.bind(this);
        this.hover = this.hover.bind(this);
        this.mouseOut = this.mouseOut.bind(this);
        this.onResize = this.onResize.bind(this);
    }

    closeMenu(evt) {
        if (evt) evt.preventDefault();

        this.el.classList.add(`close-animation`);
        this.el.classList.remove(`animation`);
        this.overlay.classList.remove(`animation`);
        if (
            this.el.getAttribute(`data-menu`) === `header-cat-dp` ||
            this.el.getAttribute(`data-menu`) === `header-search`
        ) {
            document.querySelector(`.header`).classList.remove(`opened`);
        }
        this.openBtns.forEach((btn) => btn.classList.remove(`active`));

        setTimeout(() => {
            this.el.classList.remove(`opened`);
            this.el.classList.remove(`close-animation`);
            this.overlay.classList.remove(`is-viewed`);
            document.body.classList.remove(`no-scroll`);
            this.overlay.removeEventListener(`click`, this.closeMenu);
            this.overlay.removeEventListener(`mouseover`, this.closeMenu);
        }, Timeout.ANIMATION_TIMEOUT);
    }

    openMenu(e) {
        console.log('open menu click')
        if (this.el.classList.contains(`opened`)) {
            this.closeMenu();
        } else {
            this.el.classList.add(`opened`);
            this.overlay.classList.add(`is-viewed`);
            if (Resolutions.IS_TAB()) document.body.classList.add(`no-scroll`);

            setTimeout(() => {
                this.el.classList.add(`animation`);
                this.overlay.classList.add(`animation`);
                this.overlay.addEventListener(`click`, this.closeMenu);
                this.overlay.addEventListener(`mouseover`, this.closeMenu);

                if (this.el.getAttribute(`data-menu`) === `header-search`) {
                    this.el.querySelector(`[data-search-input]`).focus();
                }
            }, Timeout.SHORT_TIMEOUT);
        }
    }

    mouseOut() {
        clearTimeout(this.setTimeoutConst);
    }

    hover(e) {
        this.setTimeoutConst = setTimeout(() => {
            this.el.classList.add(`opened`);
            this.overlay.classList.add(`is-viewed`);

            console.log('hover')

            if (
                this.el.getAttribute(`data-menu`) === `header-cat-dp` ||
                this.el.getAttribute(`data-menu`) === `header-search`
            ) {
                document.querySelector(`.header`).classList.add(`opened`);
            }

            setTimeout(() => {
                e.target.classList.add(`active`);
                this.el.classList.add(`animation`);
                this.overlay.classList.add(`animation`);
                this.overlay.addEventListener(`click`, this.closeMenu);
                this.overlay.addEventListener(`mouseover`, this.closeMenu);
            }, Timeout.SHORT_TIMEOUT);
        }, Timeout.ANIMATION_TOGGLE);
    }

    // listeners
    addEventListeners() {
        if (this.openBtns.length) {
            [].forEach.call(this.openBtns, (openBtn) => {
                if (Resolutions.IS_DP()) {
                    openBtn.removeEventListener(`click`, this.openMenu);
                    openBtn.addEventListener(`mouseover`, this.hover);
                    openBtn.addEventListener(`mouseout`, this.mouseOut, false);
                } else {
                    openBtn.removeEventListener(`mouseover`, this.hover);
                    openBtn.removeEventListener(`mouseout`, this.mouseOut, false);
                    openBtn.addEventListener(`click`, this.openMenu);
                }
            });
        }

        if (this.closeBtns.length) {
            [].forEach.call(this.closeBtns, (closeBtn) => {
                closeBtn.addEventListener(`click`, this.closeMenu);
            });
        }
    }

    onResize() {
        this.closeMenu();
    }

    init() {
        if (!this.el) return;
        this.addEventListeners();
        isWidthResize(this.onResize);
    }
}

export const initMenu = () => {
    const blocks = document.querySelectorAll(`[data-menu]`);
    blocks.forEach(block => new Menu(block).init());
};

window.initMenu = (el) => new Menu(el).init();
